import Hero from "./Hero.js";
import Servis from "./Servis.js";
import WhyUs from "./WhyUs.js";
import FAQ from "./faq";
import TypeS from "./TypeS.js";
import Whats from "./whats";


const Index = () => {
    return (
        <div>
            <Hero />
            <Whats />
            <Servis />
            <WhyUs />
            <TypeS />
            <FAQ />
        </div>
    )
}

export default Index;